import React from 'react'
import {matchPath} from 'react-router-dom'

import LocalAsyncStore from '../../local-async-store'
import AuthorisedGuard from './authorised-guard'
import View from './views'

export const serviceParams = (pathname) => {
  const match = matchPath(pathname, {path: '/(services||providers||gov-registrations|provider-registrations)/:id'})

  return match ?
    {
      id: match.params.id,
      base_url: match.url,
      type: match.params['0']
    } :
    {}
}

export const findRegHolder = (reg_holders = {}, {id, type, base_url}) => {

  const reg_holder = reg_holders.find(reg => String(reg[getRegID(type)]) === id)
  return reg_holder ?
    {
      base_url,
      ...reg_holder
    } :
    null
}

const getRegID = (type) => {
  switch (type) {
  case 'services':
    return 'type_id'
  case 'providers':
    return 'type_id'
  case 'gov-registrations':
    return 'id'
  default:
    return null
  }
}

export const AuthorisedLayout = ({reg_holders, location, isEmbedded, children}) => (
  <AuthorisedGuard
    records={reg_holders.data}
    loading={reg_holders.loading}
  >
    <View
      isEmbedded={isEmbedded}
      current_reg_holder={
        findRegHolder(
          reg_holders.data || [],
          serviceParams(location.pathname)
        )
      }
    >
      {children}
    </View>
  </AuthorisedGuard>
)

export default LocalAsyncStore(
  'reg_holders',
  AuthorisedLayout,
  () => '/api/registration-holders'
)



// WEBPACK FOOTER //
// ./src/layout/authorised-layout/index.js